import React, { useState } from 'react';
import Navbar from '../Components/NavBarAirbnbStyle';
import Footer from '../Components/footer';
import Kamay1 from '../images/kamay1.jpg';
import Kamay2 from '../images/kamay2.jpg';
import './eventsProximo.css';
import WhatsAppButton from '../Components/whatsappbutton';

const Events = () => {
    return (
        <div>
            <Navbar />
            <WhatsAppButton />

            <div className='contenedor-events'>
                <div className='direfrentes_eventos'>
                    <img src={Kamay1} alt="Kamay1" class="Kamay1" />
                    <img src={Kamay2} alt="Kamay2" class="Kamay2" />
                </div>
            </div>
        </div>

    );

};


export default Events;